// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';
import unverified from 'imgs/unverifiedAccount.png';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
};

const UnverifiedModal = (props: Props) => {
  const {
    visible,
    close,
    submit,
  } = props;

  const DeleteVendor = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteVendor} type="primary">Proceed</SpButton>,
      ]}
      title="Confirm Transfer to Unverified Account"
    >
      <div className="px-4">
        <div className="mt-1">
          <img src={unverified} alt="unverified contact" width="485" />
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default UnverifiedModal;
